import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import { HiArrowRight } from 'react-icons/hi'

interface FinalCTASectionProps {
  onCTAClick: () => void
}

export function FinalCTASection({ onCTAClick }: FinalCTASectionProps) {
  const ref = useRef<HTMLElement>(null)
  const isInView = useInView(ref, { once: true, margin: '-100px' })

  return (
    <section ref={ref} className="final-cta-section">
      <div className="final-cta-bg" />

      <div className="final-cta-content">
        <motion.h2
          className="final-cta-title"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          Ready to Bet Smarter?
        </motion.h2>

        <motion.p
          className="final-cta-subtitle"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Join hundreds of bettors who use StatScout to make data-driven decisions.
          Start your free trial today.
        </motion.p>

        <motion.div
          className="final-cta-buttons"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <button className="cta-button large pulse" onClick={onCTAClick}>
            Start 7-Day Free Trial
            <HiArrowRight />
          </button>
        </motion.div>
      </div>
    </section>
  )
}
